
import React,{ useState, useEffect } from "react"

const Default = (props) => {
    const [value, setValue] = useState('')
    let propsSelect = {...props}
    delete propsSelect['tipoValue']

    const getSelectedClave = () => {
        if (props.tipoValue === 1) {
            return value || props.value || ''
        }
        return props.value ? props.value : value
    }

    const getDataValueForClave = (clave) => {
        if (!props.datos || !clave) return ''
        const item = props.datos.find((s) => s.clave == clave)
        if (!item) return ''
        if (item.label && String(item.label).includes(item.clave)) {
            return String(item.label)
        }
        return `${item.clave}${item.label ? ' - ' + item.label : ''}`
    }

    useEffect(()=> {
        if (!value && props.value) {
            setValue(props.value)
        }
    },[props.value])

    const onChange = (e) => {
        let value = e.target.value
        let item = props.datos ? props.datos.find((s) => s.clave == value) : undefined
        item = item !== undefined && item !== null?item:{clave:''}
        setValue(item.clave)
        // Si se pide explícitamente, actualizar dataset.value con clave + label
        if (props.includeDataValue) {
            try {
                if (e && e.target && e.target.dataset) {
                    let dataVal = ''
                    if (item.label && String(item.label).includes(item.clave)) {
                        dataVal = String(item.label)
                    } else {
                        dataVal = `${item.clave}${item.label ? ' - ' + item.label : ''}`
                    }
                    e.target.dataset.value = dataVal
                }
            } catch (err) { }
        }
        props.onChange({item, e})
    }

    const handleMouseDown = (e) => {
        // Evitar que se despliegue el dropdown si `disableDropdown` es true
        if (props.disableDropdown) {
            e.preventDefault()
        }
    }

    const selectedClave = getSelectedClave()
    const dataValue = getDataValueForClave(selectedClave)

    return (
    <select
        {...propsSelect}
        className="form-control form-control-md"
        onChange={props.onChange?onChange:null}
        value={props.tipoValue === 1? (value || props.value): (props.value? (props.value): value)}
        onMouseDown={handleMouseDown}
        {...(props.includeDataValue ? { 'data-value': dataValue } : {})}
    >
        <option value="">{props.placeholder?props.placeholder: 'Seleccionar opción'}</option>
        {props.datos?
            props.datos.map((v, i) => (
                <option key={v.clave+'-'+i} value={v.clave}>{v.label}</option>
            ))
        : ''}
    </select>)
}

export default Default